module.exports = __webpack_public_path__ + "static/media/bunny_3.51015d70.jpg";